module.exports = __webpack_public_path__ + "static/media/angry_bee.afa6cd32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bee/angry_bee.png
// module id = 159
// module chunks = 0